var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDowngraph(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.2,
    cx: 12,
    cy: 12,
    r: 12,
    fill: "#E61E50"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.0711 15.7211C15.4301 15.7211 15.7211 15.4301 15.7211 15.0711L15.7211 9.22107C15.7211 8.86208 15.4301 8.57107 15.0711 8.57107C14.7121 8.57107 14.4211 8.86208 14.4211 9.22107L14.4211 14.4211L9.22107 14.4211C8.86208 14.4211 8.57107 14.7121 8.57107 15.0711C8.57107 15.4301 8.86208 15.7211 9.22107 15.7211L15.0711 15.7211ZM7.54038 8.45962L14.6114 15.5307L15.5307 14.6114L8.45962 7.54038L7.54038 8.45962Z",
    fill: "#E75744"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDowngraph);
export default __webpack_public_path__ + "static/media/downgraph.87575d13096ae0c15923e8100fa343c4.svg";
export { ForwardRef as ReactComponent };